import { v4 as uuid } from "uuid";
import { AxiosError } from "axios";
import { Box, Typography } from "@mui/material";
import { useRef, useEffect, useContext, useState } from "react";
import Card from "../../../components/card/card";
import { VisitTimeStyled } from "./visit-time.styles";
import { useAppDispatch } from "../../../../../store/hooks";
import SlotCard from "../../../components/slot-card/slot-card";
import { getMoreUserAppointmentsSlots } from "../../../../../actions";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { LightButton } from "../../../../../components/button/button";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import { isSomething } from "../../../../../utils/common-utils";

const VisitTime = () => {
  const {
    state: { timeSlots, selectedTimeSlot, activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);

  const timeSlotList = timeSlots?.timeSlots || [];
  const cacheKey = timeSlots?.cacheKey;
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleMore = () => {
    setIsLoading(true);
    getMoreUserAppointmentsSlots({ cacheKey })
      .then((response) => {
        const { timeSlots: responseTimeSlots, cacheKey } = response.data.data;
        const newEntries: any = Object.values(responseTimeSlots);

        console.log(response.data.data);

        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_TIME_SLOTS,
          payload: {
            ...timeSlots,
            timeSlots: [...timeSlotList, ...newEntries],
            cacheKey,
          },
        });
      })
      .catch((error: AxiosError) => {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: error.message,
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const slotsWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isLoading && slotsWrapperRef.current) {
      slotsWrapperRef.current.scrollTo({
        top: slotsWrapperRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [timeSlotList.length, isLoading]);

  console.log({ timeSlotList });

  return (
    <Card
      title="Select visit time"
      description="Following are the recommended time slots. Please select one of the options to continue."
      btnTitle="Continue"
      onHandleClick={() => {
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep + 1,
        });
      }}
      showBackButton={timeSlotList.length === 0}
      handleBack={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep - 2,
        })
      }
      progress={activeStep * 5}
      disabledConfirmBtn={!isSomething(selectedTimeSlot)}
    >
      <VisitTimeStyled>
        <Box className="slots-wrapper" ref={slotsWrapperRef}>
          {timeSlotList.length > 0 ? (
            timeSlotList.map((d: any, index: number) => (
              <SlotCard key={index} slot={d} />
            ))
          ) : (
            <Typography
              className="no-slots-message"
              variant="h6"
              color="textSecondary"
            >
              Call the office for an appointment.
            </Typography>
          )}
        </Box>
        {timeSlotList.length > 0 && (
          <Box className="lightbtn-wrapper" sx={{ width: "100%" }}>
            <LightButton
              className="load-more"
              disabled={!isSomething(cacheKey) || isLoading}
              onClick={handleMore}
              isLoading={isLoading}
            >
              Load more
            </LightButton>
          </Box>
        )}
      </VisitTimeStyled>
    </Card>
  );
};

export default VisitTime;
